import { Checkbox, Form, FormInstance } from 'antd';
import { FormConfigProps } from '../constants/constants';
import { customValidator } from '../functions/validation';
import { DynamicFormField } from './DynamicFormField';

type CheckboxItemProps = {
  item: FormConfigProps;
  formPathParams: string[];
  paddingLeft?: number;
  form: FormInstance;
};

export const CheckboxItem = ({
  item,
  formPathParams,
  paddingLeft,
  form,
}: CheckboxItemProps) => {
  return (
    <>
      <Form.Item
        name={[...formPathParams, item.value]}
        valuePropName="checked"
        style={{ marginBottom: 4, paddingLeft: paddingLeft }}
        rules={item.children && [{ validator: customValidator() }]}
      >
        <Checkbox>{item.label}</Checkbox>
      </Form.Item>
      {item.children && (
        <DynamicFormField
          key={`${item.value}_child`}
          formItemConfig={item.children}
          formPathParams={[...formPathParams, item.value]}
          form={form}
        />
      )}
    </>
  );
};
